import React, { useState, useEffect } from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

const ScrollFAB: React.FC = () => {

  const [showButton, setShowButton] = useState(false);
  const [atBottom, setAtBottom] = useState(false);

  const checkScrollPosition = () => {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    setShowButton(scrollPosition > 100);
    setAtBottom(scrollPosition + windowHeight >= documentHeight - 100);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);
    return () => window.removeEventListener('scroll', checkScrollPosition);
  }, []);

  const scrollTo = (position: 'top' | 'bottom') => {
    window.scrollTo({
      behavior: 'smooth',
      top: position === 'top' ? 0 : document.documentElement.scrollHeight,
    });
  };

  return showButton ? (
    <AnimatePresence>
  {showButton && (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5 }}
      className="fixed right-6 bottom-6 z-50"
    >
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => scrollTo(atBottom ? 'top' : 'bottom')}
        className="p-3 bg-goldenHover rounded-full shadow-lg text-white hover:bg-primary-dark transition-colors"
      >
        {atBottom ? <ArrowUp size={32} strokeWidth={3} className='text-primary' /> : <ArrowDown size={32} strokeWidth={3} className='text-primary'/>}
      </motion.button>
    </motion.div>
  )}
</AnimatePresence>
  ) : null;
};

export default ScrollFAB;